import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	componentDeletionFailedTitle: {
		id: 'project-components.flags.component-deletion-failed-title',
		defaultMessage: "We couldn't delete the component",
		description:
			"Flag's title - appears when component couldn't be deleted. For example: user is offline.",
	},
	componentDeletionFailedDescription: {
		id: 'project-components.flags.component-deletion-failed-description',
		defaultMessage: 'Something went wrong. Try again.',
		description:
			"Flag's description - appears when component couldn't be deleted. For example: user is offline.",
	},
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (): FlagConfiguration => ({
	type: 'error',
	isAutoDismiss: false,
	title: messages.componentDeletionFailedTitle,
	description: messages.componentDeletionFailedDescription,
	messageId: 'project-directories.components.flags.delete.flag.error',
	messageType: 'transactional',
});
